import { render, staticRenderFns } from "./Grade6ResultTable.vue?vue&type=template&id=22bcdcfb&"
import script from "./Grade6ResultTable.vue?vue&type=script&lang=js&"
export * from "./Grade6ResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports